import React, {startTransition, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import CustomTextField from "../components/CustomTextField.tsx";
import axios from 'axios';
import Tab from "@mui/material/Tab";
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {Remove} from "@mui/icons-material";
import "../App.css";
import "../CSS/programmes/ListingCreator.css";
import {DefaultButton, SubmitButton} from "../components/Buttons.tsx";
import {ColorModeIcon} from "../context/ColorModeContext.tsx";
import {useCurrentApp} from "../context/CurrentAppContext";
import Navbar from "../components/Navbar.tsx";
import {IconButton} from "@mui/material";
import SearchableMultiSelect from "../components/SearchableMultiSelect.tsx";
import {Helmet} from "react-helmet";

// interface TabPanelProps {
//     children?: React.ReactNode;
//     index: number;
//     value: number;
// }
// const tabStyle = {
//   '&.Mui-selected': {
//     color: 'var(--naturGreen)',
//   }
// }
// function CustomTabPanel(props: TabPanelProps) {
//   const {children, value, index, ...other} = props;
//   if (value !== index) return null;
//
//   return (<div
//     role="tabpanel"
//     id={`tab-${index}`}
//     aria-labelledby={`tab-${index}`}
//     style={{
//       width: '100%', minHeight: '300px', // Only active panel gets this height
//       display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'start',
//     }}
//     {...other}
//   >
//     {children}
//   </div>);
// }




const renderInfoMessage = (infoMessage) => {
    if (infoMessage) {
        return (
            <div className="info-message-container">
                {" "}
                <p>{infoMessage}</p>{" "}
            </div>
        );
    } else {
        return null;
    }
};
const renderErrorMessage = (errorMessage) => {
    if (errorMessage) {
        return (<div className="error-message-container">
            {" "}
            <p>{errorMessage}</p>{" "}
        </div>);
    } else {

        return null;
    }
};

function ListingCreator() {
    const backendUrl = import.meta.env.VITE_REACT_APP_BACKEND_URL;

    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    };

    // Current app, which is used to update the current app in the Navbar, when navigating to another page
    const {setCurrentApp} = useCurrentApp();

    // Tab
    const [currentTab, setCurrentTab] = React.useState('1');
    const handleChange = (event: React.SyntheticEvent, newTab: string) => {
        event.preventDefault();
        setCurrentTab(newTab);
    };

    // state is undefined when opened from main menu, defaults kick in
    const {state} = useLocation();

    const navigate = useNavigate();

    const [itemID, setItemID] = useState<string>("");
    const [varID, setVarID] = useState<string>("");
    const [ebayID1, setEbayID1] = useState<string>("");
    const [ebayID2, setEbayID2] = useState<string | null>("");
    const [hoodID, setHoodID] = useState<string | null>("");
    const [requiredTextfields, setRequiredTextfields] = useState([])
    const defaultListingTemplages = [
        {value: '14', label: '1_eBay_AT_2022 (14)', name: '1_eBay_AT_2022', layout_id: 14, ref_id: '2.05'},
        {value: '11', label: '1_eBay_DE_2022 (11)', name: '1_eBay_DE_2022', layout_id: 11, ref_id: '2.08'},
        {value: '10', label: '1_Hood_2022 (10)', name: '1_Hood_2022', layout_id: 10, ref_id: '125'},
        //{value: '13', label: '1_ricardo_2020 (13)', name: '1_ricardo_2020', layout_id: 13, ref_id: ''}
    ];
    const [listingTemplates, setListingTemplates] = useState(defaultListingTemplages);
    const [selectedListingTemplates, setSelectedListingTemplates] = useState([]);

    // Shows button to create a new listing or go to ItemCreator
    const [listingUploadSuccessful, setListingUploadSuccessful] = useState(false);

    // Renders the page where an item id has to be entered
    const [renderMainPage, setRenderMainPage] = useState(true) //TODO set to true again for deployment

    // Hooks for values for the following textfields
    const [breite, setBreite] = useState<string>("");
    const [hoehe, setHoehe] = useState<string>("");
    const [laenge, setLaenge] = useState<string>("");
    const [groesse, setGroesse] = useState<string>("");
    const [liegeflaeche, setLiegeflaeche] = useState<string>("");
    const [setEnthaelt, setSetEnthaelt] = useState<string>("");
    const [anzRegalfaecher, setAnzRegalfaecher] = useState<string>("");
    const [anzSchubladen, setAnzSchubladen] = useState<string>("");
    const [anzTeile, setAnzTeile] = useState<string>("");
    const [herstellernummer, setHerstellernummer] = useState<string>("");
    const [marke, setMarke] = useState<string>("Natur24");
    const [farbe, setFarbe] = useState<string>("");
    const [material, setMaterial] = useState<string>("");
    const [produktart, setProduktart] = useState<string>("");
    const [polsterstoff, setPolsterstoff] = useState<string>("");
    const [gestellmaterial, setGestellmaterial] = useState<string>("");

    // Textfields for all the Pflichtfelder that can appear
    const textFieldConfigs = [
        {label: "Marke", value: marke, setValue: setMarke, inputMode: "text"},
        {label: "Länge", value: laenge, setValue: setLaenge, inputMode: "decimal"},
        {label: "Breite", value: breite, setValue: setBreite, inputMode: "decimal"},
        {label: "Höhe", value: hoehe, setValue: setHoehe, inputMode: "decimal"},
        {label: "Größe", value: groesse, setValue: setGroesse, inputMode: "text"},
        {label: "Farbe", value: farbe, setValue: setFarbe, inputMode: "text"},
        {label: "Material", value: material, setValue: setMaterial, inputMode: "text"},
        {label: "Liegefläche", value: liegeflaeche, setValue: setLiegeflaeche, inputMode: "text"},
        {label: "Set enthält", value: setEnthaelt, setValue: setSetEnthaelt, inputMode: "text"},
        {label: "Anzahl der Regalfächer", value: anzRegalfaecher, setValue: setAnzRegalfaecher, inputMode: "integer"},
        {label: "Anzahl der Schubladen", value: anzSchubladen, setValue: setAnzSchubladen, inputMode: "integer"},
        {label: "Anzahl der Teile", value: anzTeile, setValue: setAnzTeile, inputMode: "integer"},
        {label: "Herstellernummer", value: herstellernummer, setValue: setHerstellernummer, inputMode: "integer"},
        {label: "Produktart", value: produktart, setValue: setProduktart, inputMode: "text"},
        {label: "Polsterstoff", value: polsterstoff, setValue: setPolsterstoff, inputMode: "text"},
        {label: "Gestellmaterial", value: gestellmaterial, setValue: setGestellmaterial, inputMode: "text"},
    ];
    // Additional Fields
    const [additionalFields, setAdditionalFields] = useState([]);
    const createEigenschaftenField = () => {
        setAdditionalFields(prev => [...prev, {id: Date.now(), key: '', value: ''}]);
    };
    const removeAdditionalField = (idToRemove) => {
        setAdditionalFields(prev => prev.filter(field => field.id !== idToRemove));
    };

    // Errors and InfoMessages
    const [itemIdError, setItemIdError] = useState<string>("");
    const [listingUploadError, setListingUploadError] = useState<string>("");
    const [listingUploadInfoMessage, setListingUploadInfoMessage] = useState<string>("");

    // State hook that gets triggered if state variables are given
    const [isStateLoading, setIsStateLoading] = useState(false);
    useEffect(() => {
        if (!state) {
            console.log("No state was passed.");
            return;
        }

        const fetchInformation = async () => {
            setIsStateLoading(true);
            console.log("Received state:", state);

            setItemID(state.itemID);
            setVarID(state.varID);
            setEbayID1(state.ebayID1);
            setEbayID2(state.ebayID2);
            setHoehe(state.Hoehe);
            setBreite(state.Breite);
            setLaenge(state.Laenge);
            setMaterial(state.Material);
            setLiegeflaeche(state.Liegeflaeche);
            setFarbe(state.Farbe);
            setHerstellernummer(state.itemID);
            setGroesse(state.Groesse);


            // Get required fields
            let areFieldsSet = false;
            const customConfig = {
                headers: {
          "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}`,
        }, params: {"ebay_category_id_1": state.ebayID1, "ebay_category_id_2": state.ebayID2}
            };
            await axios.get(`${backendUrl}/listing_creator/get_fields_for_ebay_ids/`, customConfig)
                .then((response) => {
                    console.log("Response: ", response.data);
                    setRequiredTextfields(response.data);
                    areFieldsSet = true;
                }).catch(() => {
                });


            // If hood ID is null, see if it can be retrieved with another request
            let _hoodID = state.hoodID;
            if (_hoodID == null || !areFieldsSet) {
                const customConfig = {
          headers: {
            "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}`,
          }, params: {item_id: state.itemID}
        };
                await axios.get(`${backendUrl}/listing_creator/get_fields_for_item_id/`, customConfig)
                    .then((response) => {
                        console.log("Response: ", response.data);
                        if (_hoodID == null) {
                            _hoodID = response.data.hood_id;
                        } else if (!areFieldsSet) {
                            setRequiredTextfields(response.data.fields);
                            areFieldsSet = true;
                        }
                    }).catch(() => {
                    });
            }

            setHoodID(_hoodID);
            // Set templates and selected templates
            // Filter templates to exclude Hood if hood_id is null
            const filteredTemplates = defaultListingTemplages.filter(t =>
                _hoodID !== null || t.layout_id !== 10
            );
            // Only include hood (layout_id 10) if hood_id is NOT null
            const defaultSelectedTemplateIDs = [11];  // DE and AT
            if (_hoodID !== null) {
                defaultSelectedTemplateIDs.push(10); // include Hood if hood_id is not null
            }
            // Select ebayDE, ebayAT and optionally hood
            const defaultSelected = filteredTemplates.filter(t =>
                defaultSelectedTemplateIDs.includes(t.layout_id)
            );
            setListingTemplates(filteredTemplates);
            setSelectedListingTemplates(defaultSelected);

            setIsStateLoading(false);
            if (areFieldsSet) {
                setRenderMainPage(false);
            } else {
                setItemIdError("Beim Laden der Felder ist ein Fehler aufgetreten. Versuche es bitte erneut!");
            }
        };

        fetchInformation();
    }, []);

    const [requiredFieldsErrors, setRequiredFieldsErrors] = useState({
        "Marke": "",
        "Länge": "",
        "Breite": "",
        "Höhe": "",
        "Größe": "",
        "Farbe": "",
        "Material": "",
        "Liegefläche": "",
        "Set enthält": "",
        "Anzahl der Regalfächer": "",
        "Anzahl der Schubladen": "",
        "Anzahl der Teile": "",
        "Herstellernummer": "",
        "Produktart": "",
        "Polsterstoff": "",
        "Gestellmaterial": "",
    });

    const [illegalFieldErrorMessage, setIllegalFieldErrorMessage] = useState(null);

    useEffect(() => {
        setIllegalFieldErrorMessage(checkIllegalRequiredFields());
    }, [requiredTextfields]);


    const renderItemIDPage = () => {
        const submitItemID = async (event: React.MouseEvent<HTMLButtonElement>) => {
            event.preventDefault();
            setItemIdError("");

            if (itemID.trim() == '') {
                setItemIdError('Die Item ID muss ausgefüllt sein');
                return;
            }

            const customConfig = {
              headers: {
                "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}`,
              }, params: {item_id: itemID.trim()}
            };
            await axios.get(`${backendUrl}/listing_creator/get_fields_for_item_id/`, customConfig)
                .then((response) => {
                    console.log("Response: ", response.data);
                    setRequiredTextfields(response.data.fields);
                    setVarID(response.data.var_id);
                    setEbayID1(response.data.ebay_id1);
                    setEbayID2(response.data.ebay_id2);
                    setHoodID(response.data.hood_id);

                    // Set templates and selected templates
                    // Filter templates to exclude Hood if hood_id is null
                    const filteredTemplates = defaultListingTemplages.filter(t =>
                        response.data.hood_id !== null || t.layout_id !== 10
                    );
                    // Only include hood (layout_id 10) if hood_id is NOT null
                    const defaultSelectedTemplateIDs = [11];  // DE and AT
                    if (response.data.hood_id !== null) {
                        defaultSelectedTemplateIDs.push(10); // include Hood if hood_id is not null
                    }
                    // Select ebayDE, ebayAT and optionally hood
                    const defaultSelected = filteredTemplates.filter(t =>
                        defaultSelectedTemplateIDs.includes(t.layout_id)
                    );

                    setListingTemplates(filteredTemplates);
                    setSelectedListingTemplates(defaultSelected);
                    setHerstellernummer(itemID);

                    setRenderMainPage(false);
                })
                .catch((err) => {
                    const error_str = (!err.response) ? "Netzwerkfehler. Deine Internetverbindung ist entweder unterbrochen oder der Server ist nicht erreichbar." // This will handle network errors or cases where the server doesn't respond at all
                        : (err.response.status === 500) ? "Interner Serverfehler. Bitte mache einen Screenshot von der Seite und schicke ihn an die Entwickler (oder Jonathan)."
                            : err.response.data?.detail?.toString();
                    setItemIdError(error_str);
                });
        };

        return (<>
                Bitte gebe eine Item ID ein
                <CustomTextField
                    label="Artikel-ID"
                    value={itemID}
                    inputMode="integer"
                    is_required={true}
                    onChange={(e) => setItemID(e.target.value.trim())}
                    style={{width: '100%'}}
                />
                <SubmitButton label={"Lade Informationen für Artikel-ID"}
                              onClick={submitItemID} manualLoading={isStateLoading}/>
                {renderErrorMessage(itemIdError)}
            </>
        )
    }


    const submitListing = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        setListingUploadError("");
        setListingUploadInfoMessage("");

        // 0. Check for invalid words
        let forbiddenWords: string[] = [];

        await axios.get(`${backendUrl}/listing_creator/get_invalid_words/`, config)
            .then((response) => {
                forbiddenWords = response.data;
            }).catch(() => {
            });

        // goes through list of forbidden words and checks if input matches some words
        const checkForbiddenWords = (text) => {
            const normalizedText = text.toLowerCase().replace(/[\s\-_\/]+/g, "");
            const foundWords = forbiddenWords.filter(word => {
                const normalizedWord = word.toLowerCase().replace(/\s+/g, "");
                return normalizedText.includes(normalizedWord);
            });
            return foundWords; // return array instead of string
        };


        // 0.1 checking for forbidden words in the required text fields

        // filled out requiered text fields
        const filledRequiredFields = textFieldConfigs
            .filter(({label}) => requiredTextfields.includes(label))      // only required ones
            .filter(({value}) => value.trim());                            // only filled


        // array of fields with forbidden words and the corresponding words
        const forbiddenWordsPerField = filledRequiredFields.reduce<Record<string, string[]>>((acc, {label, value}) => {
            const words = checkForbiddenWords(value);
            if (words.length) {
                acc[label] = words;
            }
            return acc;
        }, {});

        // Convert array to formatted string
        const forbiddenWordsMessage = 'Folgende Pflichtfelder enthalten unzulässinge Worte (in gleicher oder ähnlicher Schreibweise): \n'
            + Object.entries(forbiddenWordsPerField)
            .map(([label, words]) => `${label}: ${words.join(', ')}`)
            .join('\n');

        // if forbidden words are found
        if(Object.keys(forbiddenWordsPerField).length > 0) {
            setListingUploadError(forbiddenWordsMessage)
            return;
        }

        // 0.2 check additionally added fields for forbidden words (their values)
        const forbiddenWordsPerAdditionalField = additionalFields.reduce<Record<string, string[]>>((acc, {
            key,
            value
        }) => {
            const words = checkForbiddenWords(value);
            if (words.length) {
                acc[key] = words;
            }
            return acc;
        }, {});

        // array of fields with forbidden words and the corresponding words
        const forbiddenWordsAdditionalFields = 'Folgende zusätzlich hinzugefügte Felder enthalten unzulässige Worte (in gleicher oder ähnlicher Schreibweise): \n'
            + Object.entries(forbiddenWordsPerAdditionalField)
                .map(([label, words]) => `${label}: ${words.join(', ')}`)
                .join('\n');

        // if forbidden words are found
        if(Object.keys(forbiddenWordsPerAdditionalField).length > 0) {
            setListingUploadError(forbiddenWordsAdditionalFields)
            return;
        }


        // 0.3 check additionally added fields for forbidden words (their names)
        const forbiddenWordsPerAdditionalFieldName = additionalFields.reduce<Record<string, string[]>>((acc, {key}) => {
            const words = checkForbiddenWords(key);     // not with value because we check the name of the field (= key)
            if (words.length) {
                acc[key] = words;
            }
            return acc;
        }, {});


        const forbiddenWordsMessageAdditionFieldsName = 'Folgende zusätzlich Felder haben Namen mit unzulässingen Worten (in gleicher oder ähnlicher Schreibweise): \n'
            + Object.entries(forbiddenWordsPerAdditionalFieldName)
                .map(([label, words]) => `${label}: ${words.join(', ')}`)
                .join('\n');

        // if forbidden words are found
        if(Object.keys(forbiddenWordsPerAdditionalFieldName).length > 0) {
            setListingUploadError(forbiddenWordsMessageAdditionFieldsName)
            return;
        }


        // 1. Check if all required fields have text entered
        const missingRequired = textFieldConfigs
            .filter(({label}) => requiredTextfields.includes(label))
            .filter(({value}) => !value.trim())
            .map(({label}) => label);

        if (missingRequired.length) {
            setListingUploadError(
                `Bitte fülle die folgenden Pflichtfelder aus: ${missingRequired.join(", ")}`
            );
            //return;
        }

        // 1.1 Set manual errors for the fields that do not have text entered
        const not_set_error = "test error message";
        const newErrors = {
            "Marke": requiredTextfields.includes("Marke") && !marke ? not_set_error : null,
            "Länge": requiredTextfields.includes("Länge") && !laenge ? not_set_error : null,
            "Breite": requiredTextfields.includes("Breite") && !breite ? not_set_error : null,
            "Höhe": requiredTextfields.includes("Höhe") && !hoehe ? not_set_error : null,
            "Größe": requiredTextfields.includes("Größe") && !groesse ? not_set_error : null,
            "Farbe": requiredTextfields.includes("Farbe") && !farbe ? not_set_error : null,
            "Material": requiredTextfields.includes("Material") && !material ? not_set_error : null,
            "Liegefläche": requiredTextfields.includes("Liegefläche") && !liegeflaeche ? not_set_error : null,
            "Set enthält": requiredTextfields.includes("Set enthält") && !setEnthaelt ? not_set_error : null,
            "Anzahl der Regalfächer": requiredTextfields.includes("Anzahl der Regalfächer") && !anzRegalfaecher ? not_set_error : null,
            "Anzahl der Schubladen": requiredTextfields.includes("Anzahl der Schubladen") && !anzSchubladen ? not_set_error : null,
            "Anzahl der Teile": requiredTextfields.includes("Anzahl der Teile") && !anzTeile ? not_set_error : null,
            "Herstellernummer": requiredTextfields.includes("Herstellernummer") && !herstellernummer ? not_set_error : null,
            "Produktart": requiredTextfields.includes("Produktart") && !produktart ? not_set_error : null,
            "Polsterstoff": requiredTextfields.includes("Polsterstoff") && !polsterstoff ? not_set_error : null,
            "Gestellmaterial": requiredTextfields.includes("Gestellmaterial") && !gestellmaterial ? not_set_error : null,
        };

        setRequiredFieldsErrors(newErrors);

        // just to makes sure that we definitely return here
        if (Object.values(newErrors).some((error) => error)) return;
        if (missingRequired.length) return;


        // 2. Check if all additional fields have text entered
        const incompleteAdditional = additionalFields
            .map((field, idx) => ({...field, idx}))  // attach original index
            .filter(({key, value}) => !key.trim() || !value.trim())
            .map(({idx}) => idx + 1);               // 1-based numbering

        if (incompleteAdditional.length) {
            setListingUploadError(
                `Bitte fülle Name und Wert für zusätzliche Eigenschaft(en) bei Eigenschaft ${incompleteAdditional.join(
                    ", "
                )} aus.`
            );

            // 2.1 go through key and value separately to set the manual errors accordingly
            const incompleteAdditionalKey = additionalFields
                .map((field, idx) => ({...field, idx}))
                .filter(({key}) => !key?.trim())
                .map(({idx}) => idx + 1); // 1-based indexing


            setAdditionalFields((prevFields) =>
                prevFields.map((field, idx) => {
                    const isIncomplete = incompleteAdditionalKey.includes(idx + 1); // because you used idx + 1
                    return {
                        ...field,
                        manualKeyError: isIncomplete,
                    };
                })
            );

            const incompleteAdditionalValue = additionalFields
                .map((field, idx) => ({...field, idx}))
                .filter(({value}) => !value?.trim())
                .map(({idx}) => idx + 1); // 1-based indexing

            setAdditionalFields((prevFields) =>
                prevFields.map((field, idx) => {
                    const isIncomplete = incompleteAdditionalValue.includes(idx + 1); // because you used idx + 1
                    return {
                        ...field,
                        manualValueError: isIncomplete,
                    };
                })
            );


            return;
        }
        // 3. Combine the additional and required fields into one dictionary
        const fieldsPayload = new Map<string, string>();
        // 3.1 add required textfield data
        textFieldConfigs
            .filter(({label}) => requiredTextfields.includes(label))
            .forEach(({label, value}) => {
                fieldsPayload.set(label, value.trim())
            });
        // 3.2 Check whether additional fields contain fields that are already in the fieldsPayload
        // or are duplicate in the additional fields
        const trimmedKeys = additionalFields.map(({key}) => key.trim());
        const dupKeys = trimmedKeys
            .filter((key, index, array) => array.indexOf(key) !== index) // detect duplicates in additionalFields
            .concat(trimmedKeys.filter(key => fieldsPayload.has(key)));
        if (dupKeys.length) {
            setListingUploadError(
                `Doppelte Feldnamen gefunden: ${dupKeys.join(", ")}`
            );
            return;
        }
        // 3.3 Add additional fields
        additionalFields.forEach(({key, value}) => {
            fieldsPayload.set(key.trim(), value.trim())
        });

        // 4. clean Listingtemplates to only include relevant fields
        const cleanedTemplates = selectedListingTemplates.map(template => ({
            name: template.name,
            layout_id: template.layout_id,
            ref_id: template.ref_id
        }))

        // 5. Upload listing
        const data = {
            item_id: itemID,
            var_id: varID,
            ebay_id1: ebayID1,
            ebay_id2: ebayID2,
            hood_id: hoodID,
            fields: Array.from(fieldsPayload.entries()),
            templates: cleanedTemplates
        };
        console.log(itemID, varID, ebayID1, ebayID2, hoodID, Array.from(fieldsPayload.entries()), cleanedTemplates);

        await axios.post(`${backendUrl}/listing_creator/upload_listings/`, data, config)
            .then((response) => {
                console.log("response successful")
                console.log(response.data)
                setListingUploadInfoMessage(response.data); // Shows InfoMessage
                setListingUploadSuccessful(true); // Shows Buttons
            })
            .catch((err) => {
                const error_str = (!err.response) ? "Netzwerkfehler. Deine Internetverbindung ist entweder unterbrochen oder der Server ist nicht erreichbar." // This will handle network errors or cases where the server doesn't respond at all
                    : (err.response.status === 500) ? "Interner Serverfehler. Bitte mache einen Screenshot von der Seite und schicke ihn an die Entwickler (oder Jonathan)."
                        : err.response.data?.detail?.toString();
                setListingUploadError(error_str);
                setListingUploadSuccessful(false);
            });
    }

    // check if the backend returns required fields for which there is no textfield in the frontend
    const checkIllegalRequiredFields = () => {
        const illegalFields = requiredTextfields.filter(
            field => !textFieldConfigs.some(config => config.label === field)
        );

        if (illegalFields.length > 0) {
            alert('Der Server erwartet mehr Eingaben als vorgesehen. Bitte mache einen Screenshot von der Seite und schicke ihn an die Entwickler (oder Jonathan).')
            let errormessage = 'Backend Fehler - Zusätzlich erwartete Pflichtfelder: '
            errormessage += illegalFields.join(', ');
            return errormessage;
        }

        return null;
    }

    // habe das ersetzt
    /*if (!state) {*/
    if (renderMainPage) {
        return (<>
            <Navbar showWarningWhenClicked={true}/>
            <Helmet>
                <title>{"Listing Erstellen"}</title>
            </Helmet>
            <div className='Tab'>
                {renderItemIDPage()}
                {ColorModeIcon()}
            </div>
        </>)
    } else {
        return (<>
            <Navbar showWarningWhenClicked={true}/>
            <Helmet>
                <title>{"Listing Erstellen"}</title>
            </Helmet>
            <h1 style={{marginTop: "50px"}}>Listing erstellen</h1>
            <div>
                {ColorModeIcon()}
                <Box sx={{width: '100%', typography: 'body1'}}>
                    <TabContext value={currentTab}>
                        <Box sx={{borderBottom: 1, border: 'none'}}>
                            <TabList onChange={handleChange}
                                     sx={{
                                         '& .MuiTabs-indicator': {
                                             display: 'none',
                                         }, '& .MuiTab-root': {
                                             color: 'gray', borderBottom: 'none', minHeight: 'unset', // optional: avoid extra height from default padding
                                         }, '& .Mui-selected': {
                                             color: 'var(--naturGreen) !important',
                                             borderBottom: '2px solid var(--naturGreen)',
                                         },
                                     }}
                            >
                                <Tab label="Pflichtfelder" value="1"/>
                                <Tab label="Weitere Eigenschaften" value="2"/>
                            </TabList>
                        </Box>
                        <Box sx={{minHeight: '600px', width: '100%', mt: 2}}>
                            <TabPanel value="1">
                                <div className={'Tab'}>
                                    <SearchableMultiSelect inputLabel={'Listingvorlagen'}
                                                           items={listingTemplates}
                                                           value={selectedListingTemplates}
                                                           setValue={setSelectedListingTemplates}
                                                           sx={{width: "300px"}}
                                                           selectAllOption={false}
                                    />
                                    Bitte fülle die Felder für das Item mit der Artikel-ID {itemID} aus
                                </div>
                                <div className="Tab" style={{gap: "15px", justifyContent: "center"}}>
                                    {textFieldConfigs
                                        .filter(({label}) => requiredTextfields.includes(label)) // This returns only the textFieldConfigs labels that are in the requiredTextfields
                                        .map(({label, value, setValue, inputMode}) => (
                                            <CustomTextField
                                                key={label}
                                                label={label}
                                                inputMode={inputMode}
                                                is_required={true}
                                                value={value}
                                                manualError={!!requiredFieldsErrors[label]}
                                                onChange={(e) => setValue(e.target.value)}
                                                sx={{width: "100%"}}
                                            />
                                        ))}
                                </div>
                                {renderErrorMessage(illegalFieldErrorMessage)}

                            </TabPanel>
                            <TabPanel value="2">
                                <div className={'Tab'}>
                                    Hier kann man weitere eigenschaften hinzufügen
                                </div>
                                <div className={'container'}>
                                    <DefaultButton label={'Eigenschaft hinzufügen'}
                                                   onClick={createEigenschaftenField}/>
                                    {additionalFields.map((field, index) => (<div
                                        key={field.id}
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: "15px",
                                            justifyContent: "center",
                                            marginTop: "10px"
                                        }}
                                    >
                                        <CustomTextField
                                            type="text"
                                            label={'Name ' + (index + 1)}
                                            value={field.key}
                                            is_required={true}
                                            manualError={field.manualKeyError}
                                            errorText="Bitte gib eine Kategorie ein"
                                            onChange={(e) => {
                                                const newFields = [...additionalFields];
                                                newFields[index].key = e.target.value;
                                                newFields[index].manualKeyError = false;   // reset manual error
                                                setAdditionalFields(newFields);
                                            }}
                                        />
                                        <CustomTextField
                                            type="text"
                                            label={'Wert ' + (index + 1)}
                                            value={field.value}
                                            is_required={true}
                                            errorText="Bitte gib einen Wert ein"
                                            manualError={field.manualValueError}
                                            onChange={(e) => {
                                                const newFields = [...additionalFields];
                                                newFields[index].value = e.target.value;
                                                newFields[index].manualValueError = false;   // reset manual error
                                                setAdditionalFields(newFields);
                                            }}
                                        />
                                        <IconButton
                                            onClick={() => removeAdditionalField(field.id)}
                                            color="error"
                                        >
                                            <Remove/>
                                        </IconButton>
                                    </div>))}
                                </div>
                            </TabPanel>
                        </Box>
                    </TabContext>
                </Box>
            </div>
            <div>
                <SubmitButton
                    label="Listings erstellen"
                    sx={{
                        width: 400, // fixed size
                    }}
                    onClick={submitListing}
                />
                {renderErrorMessage(listingUploadError)}
                {renderInfoMessage(listingUploadInfoMessage)}
            </div>
            {listingUploadSuccessful &&
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "50px",
                    width: "100%",
                    justifyContent: "center",
                    marginTop: "15px"
                }}>
                    <DefaultButton label={"Neuen Artikel erstellen"} onClick={() => {
                        setCurrentApp("ItemCreator");
                        startTransition(() => {
                            navigate("/ItemCreator");
                        });
                    }}
                                   sx={{width: "73%", minWidth: "35%"}}/>
                </div>
            }
        </>)
    }

}

export default ListingCreator;